export default {
  namespaced: true,
  state: {
    isChecked: false,
    isMultiple: 0,//0正常模式，1多引导模式，2第二就诊人
    buttonTop: null,
    flowNodeList: [{
      'type': 1,
      'isGroup': 0,
      'hasCurrent': null,
      'guideList': [
        {
          'id': 17055,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '',
          'shift': '下午',
          'clinicTime': 1659507960000,
          'type': 'A',
          'childTypeKey': 100,
          'childType': '预约挂号',
          'typeStatus': 1,
          'description': '距离您的预约还有<span class=\'emphatic-card-text\'>0</span>天，请在<span class=\'emphatic-card-text\'>08月03日下午13:56-14:26</span>到达医院',
          'guideText': '请在<span class=\'emphatic-card-text\'>08月03日下午13:56-14:26</span>到达医院',
          'remark': '来院时请佩戴口罩，如无法按时前往就诊，请在就诊日0点前取消预约',
          'pass': '',
          'patNum': '16',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': 15,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        }
      ]
    },
    {
      'type': 2,
      'isGroup': 0,
      'hasCurrent': 1,
      'guideList': [
        {
          'id': 17056,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '',
          'shift': '下午',
          'clinicTime': 1659507960000,
          'type': 'A',
          'childTypeKey': 110,
          'childType': '去医院',
          'typeStatus': 0,
          'description': '请在<span class=\'emphatic-card-text\'>08月03日下午13:56-14:26</span>到达医院',
          'guideText': '请在<span class=\'emphatic-card-text\'>08月03日下午13:56-14:26</span>到达医院',
          'remark': '到院后请凭有效证件至自助挂号机或人工窗口取号',
          'pass': '',
          'patNum': '16',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 1,
          'totalAmount': 15,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        }
      ]
    },
    {
      'type': 3,
      'isGroup': 1,
      'hasCurrent': null,
      'guideList': [
        {
          'id': 17054,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '',
          'shift': '下午',
          'clinicTime': 1659507960000,
          'type': 'A',
          'childTypeKey': 120,
          'childType': '去取号',
          'typeStatus': 0,
          'description': '请凭有效证件前往各楼层自助挂号机或人工窗口取号',
          'guideText': '请前往各楼层自助挂号机取号',
          'remark': '请根据挂号凭条信息前往相应诊室签到',
          'pass': '',
          'patNum': '16',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': 15,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 17052,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '21204',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '陈瑞哲',
          'shift': '下午',
          'clinicTime': 1659507936000,
          'type': 'C',
          'childTypeKey': 210,
          'childType': '去签到',
          'typeStatus': 0,
          'description': '请前往<span class=\'emphatic-card-text\'>宫颈疾病专科门诊</span>，在自助签到机签到候诊',
          'guideText': '请前往<span class=\'emphatic-card-text\'>宫颈疾病专科门诊</span>，在自助签到机签到候诊',
          'remark': '可以通过输入病案号、扫描挂号单二维码、刷自费卡等方式进行签到',
          'pass': '',
          'patNum': '16',
          'currentNum': '16',
          'currentName': '小祺',
          'waitNum': '0',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': 0,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 17051,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '21204',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '陈瑞哲',
          'shift': '下午',
          'clinicTime': 1659507936000,
          'type': 'C',
          'childTypeKey': 250,
          'childType': '去就诊',
          'typeStatus': 0,
          'description': '请在<span class=\'emphatic-card-text\'>1号楼6楼B区</span>候诊，关注现场叫号信息，听到呼叫后请前往诊室门口候诊',
          'guideText': '请在<span class=\'emphatic-card-text\'>1号楼6楼B区</span>候诊，当前还需等待<span class=\'emphatic-card-text\'>0</span>人，听到呼叫后请前往诊室门口候诊',
          'remark': '70岁及以上老年人本人、残疾人、现役军人，可凭证件优先照顾',
          'pass': '',
          'patNum': '16',
          'currentNum': '16',
          'currentName': '小祺',
          'waitNum': '0',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': 0,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 17053,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '21204',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '陈瑞哲',
          'shift': '下午',
          'clinicTime': 1659507936000,
          'type': 'C',
          'childTypeKey': 310,
          'childType': '门诊中',
          'typeStatus': 0,
          'description': '医生接诊中',
          'guideText': '医生接诊中',
          'remark': '',
          'pass': '',
          'patNum': '16',
          'currentNum': '16',
          'currentName': '小祺',
          'waitNum': '0',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        }
      ]
    },
    {
      'type': 4,
      'isGroup': 0,
      'hasCurrent': null,
      'guideList': [
        {
          'id': 17074,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '21204',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '陈瑞哲',
          'shift': '',
          'clinicTime': 1659495771000,
          'type': 'D',
          'childTypeKey': 330,
          'childType': '去缴费',
          'typeStatus': 0,
          'description': '您有一张新的缴费结算单，点击查看清单可查看缴费单详情',
          'guideText': '您有一张新的缴费结算单，点击查看清单可查看缴费单详情',
          'remark': '请及时在自助机或人工窗口缴费，在线缴费仅支持自费。医生诊间预约好的检查请留意手机短信',
          'pass': '',
          'patNum': '',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': 165,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        }
      ]
    },
    {
      'type': 5,
      'isGroup': 0,
      'hasCurrent': null,
      'guideList': []
    },
    {
      'type': 6,
      'isGroup': 1,
      'hasCurrent': null,
      'guideList': [
        // 预约检查节点
        {
          'id': 17089,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '21204',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '陈瑞哲',
          'shift': '',
          'clinicTime': 1659495771000,
          'type': 'D',
          'childTypeKey': 421,
          'childType': '去检查（超声）·检查预约',
          'typeStatus': 0,
          'description': '请完成检查预约',
          'guideText': '请完成检查预约',
          'remark': '',
          'pass': '',
          'patNum': '',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '经阴道三维子宫附件超声检查',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 17090,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '21204',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '陈瑞哲',
          'shift': '',
          'clinicTime': 1659495771000,
          'type': 'D',
          'childTypeKey': 420,
          'childType': '去检查（超声）·取号-经阴道三维子宫附件超声检查',
          'typeStatus': 0,
          'description': '以下项目检查当日请到<span class=\'emphatic-card-text\'>各就诊楼层超声取号机上自助取号，并至相应科室先签到再等候检查！(检查前请排空小便)。如需预约，请在微信公众号上预约！',
          'guideText': '以下项目检查当日请到<span class=\'emphatic-card-text\'>各就诊楼层超声取号机上自助取号，并至相应科室先签到再等候检查！(检查前请排空小便)。如需预约，请在微信公众号上预约！',
          'remark': '',
          'pass': '',
          'patNum': '',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '经阴道三维子宫附件超声检查',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 17067,
          'patientName': '小祺',
          'patientCard': '06452878',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '超声二科',
          'doctorName': '',
          'shift': '上午',
          'clinicTime': null,
          'type': 'D',
          'childTypeKey': 424,
          'childType': '去检查（超声）·签到·经阴道三维子宫附件超声检查',
          'typeStatus': 0,
          'description': '请前往<span class=\'emphatic-card-text\'>2号楼2楼超声二科</span>，扫码或者输入病案号在自助签到机签到',
          'guideText': '请前往<span class=\'emphatic-card-text\'>2号楼2楼超声二科</span>，扫码或者输入病案号在自助签到机签到',
          'remark': '最早可按候诊时间提前1小时签到，超过候诊时间1小时未签到者，由服务台人工安排',
          'pass': '',
          'patNum': '7155',
          'currentNum': '',
          'currentName': '',
          'waitNum': '0',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '经阴道三维子宫附件超声检查',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 17071,
          'patientName': '小祺',
          'patientCard': '06452878',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '超声二科',
          'doctorName': '',
          'shift': '上午',
          'clinicTime': null,
          'type': 'D',
          'childTypeKey': 425,
          'childType': '去检查（超声）·就诊·经阴道三维子宫附件超声检查',
          'typeStatus': 0,
          'description': '请在<span class=\'emphatic-card-text\'>2号楼2楼超声二科</span>等待检查，关注现场叫号信息。当前还需等待大约<span class=\'emphatic-card-text\'>0</span>人',
          'guideText': '请在<span class=\'emphatic-card-text\'>2号楼2楼超声二科</span>等待检查，关注现场叫号信息。当前还需等待大约<span class=\'emphatic-card-text\'>0</span>人',
          'remark': '请按照检验回执单提示，前往相应区域自助取单机扫码或输入病案号取检验报告',
          'pass': '',
          'patNum': '7155',
          'currentNum': '',
          'currentName': '',
          'waitNum': '0',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '经阴道三维子宫附件超声检查',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        }
      ]
    },
    {
      'type': 7,
      'isGroup': 1,
      'hasCurrent': null,
      'guideList': [
        {
          'id': 17089,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '21204',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '陈瑞哲',
          'shift': '',
          'clinicTime': 1659495771000,
          'type': 'D',
          'childTypeKey': 411,
          'childType': '去检验·取号-血常规',
          'typeStatus': 0,
          'description': '以下项目周一至周五请就近到<span class=\'emphatic-card-text\'>1号楼3楼或3号楼3楼检验中心</span>执行；周六周日请到<span class=\'emphatic-card-text\'>1号楼3楼检验中心</span>执行(节假日除外)',
          'guideText': '以下项目周一至周五请就近到<span class=\'emphatic-card-text\'>1号楼3楼或3号楼3楼检验中心</span>执行；周六周日请到<span class=\'emphatic-card-text\'>1号楼3楼检验中心</span>执行(节假日除外)',
          'remark': '',
          'pass': '',
          'patNum': '',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '血常规',
          'noteNo': [{
            'id': 9,
            'noticeNo': 12,
            'description': 'US自助签到小票',
            'type': 1,
            'content': '1、请按预约时间提前到达检查科室，并在自助签到机上签到。\n2、签到时，请输入病案号或扫描条形码。\n3、签到后请勿离开，等候呼叫。\n4、患者过号请重新签到；如有疑问请咨询超声科服务台。\n5、截止签到时间：上午11：45：下午16：45。',
            'createTime': 1692559709000,
            'updateTime': 1692559709000
          }],
          'knowledgeId': 'A0EA25D997F9473282D000C8A52691F1',
          'timeState' : '1',
          'deptWaitTime': null,
          'suggestionAddress': '建议取号地址:3号楼3楼检验中心，预计等候人数:10',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 17072,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '3301',
          'deptName': '检验科',
          'doctorName': '3号楼3楼抽血',
          'shift': '不区分上下午',
          'clinicTime': null,
          'type': 'D',
          'childTypeKey': 413,
          'childType': '去检验·就诊',
          'typeStatus': 0,
          'description': '当前还需等待<span class=\'emphatic-card-text\'>0</span>人后可检验',
          'guideText': '当前还需等待<span class=\'emphatic-card-text\'>0</span>人后可检验',
          'remark': '您当前共有1个检验项目',
          'pass': '',
          'patNum': '422',
          'currentNum': '458',
          'currentName': '',
          'waitNum': '-36',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        }
      ]
    },
    {
      'type': 8,
      'isGroup': 1,
      'hasCurrent': 1,
      'guideList': [
        {
          'id': 3611496,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '普通内科',
          'doctorName': '',
          'shift': '下午',
          'clinicTime': 1659682440000,
          'type': 'A',
          'childTypeKey': 100,
          'childType': '预约挂号',
          'typeStatus': 1,
          'description': '距离您的预约还有<span class=\'emphatic-card-text\'>2</span>天，请在<span class=\'emphatic-card-text\'>08月05日下午14:24-14:54</span>到达医院',
          'guideText': '请在<span class=\'emphatic-card-text\'>08月05日下午14:24-14:54</span>到达医院',
          'remark': '来院时请佩戴口罩，如无法按时前往就诊，请在就诊日0点前取消预约',
          'pass': '66780942',
          'patNum': '15',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': 15,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659628800000,
          'compareVO': null
        },
        {
          'id': 3611497,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '普通内科',
          'doctorName': '',
          'shift': '下午',
          'clinicTime': 1659682440000,
          'type': 'A',
          'childTypeKey': 110,
          'childType': '去医院',
          'typeStatus': 0,
          'description': '请在<span class=\'emphatic-card-text\'>08月05日下午14:24-14:54</span>到达医院',
          'guideText': '请在<span class=\'emphatic-card-text\'>08月05日下午14:24-14:54</span>到达医院',
          'remark': '到院后请凭有效证件至自助挂号机或人工窗口取号',
          'pass': '66780942',
          'patNum': '15',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 1,
          'totalAmount': 15,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659628800000,
          'compareVO': null
        },
        {
          'id': 3611495,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '普通内科',
          'doctorName': '',
          'shift': '下午',
          'clinicTime': 1659682440000,
          'type': 'A',
          'childTypeKey': 120,
          'childType': '去取号',
          'typeStatus': 0,
          'description': '请凭有效证件前往各楼层自助挂号机或人工窗口取号',
          'guideText': '请前往各楼层自助挂号机取号',
          'remark': '请根据挂号凭条信息前往相应诊室签到',
          'pass': '66780942',
          'patNum': '15',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': 15,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659628800000,
          'compareVO': null
        },
        {
          'id': 3611496,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '普通内科',
          'doctorName': '',
          'shift': '下午',
          'clinicTime': 1659682440000,
          'type': 'A',
          'childTypeKey': 210,
          'childType': '去签到',
          'typeStatus': 0,
          'description': '请前往<span class=\'emphatic-card-text\'>1号楼2楼A区</span>，在自助签到机签到候诊',
          'guideText': '请前往<span class=\'emphatic-card-text\'>1号楼2楼A区</span>，在自助签到机签到候诊',
          'remark': '可以通过输入病案号、扫描挂号单二维码、刷自费卡等方式进行签到',
          'pass': '66780942',
          'patNum': '15',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': 15,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659628800000,
          'compareVO': null
        },
        {
          'id': 3611496,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '普通内科',
          'doctorName': '',
          'shift': '下午',
          'clinicTime': 1659682440000,
          'type': 'A',
          'childTypeKey': 250,
          'childType': '去就诊',
          'typeStatus': 0,
          'description': '请在<span class=\'emphatic-card-text\'>1号楼2楼A区</span>候诊，关注现场叫号信息，听到呼叫后请前往诊室门口候诊',
          'guideText': '请在<span class=\'emphatic-card-text\'>1号楼2楼A区</span>候诊，关注现场叫号信息，听到呼叫后请前往诊室门口候诊',
          'remark': '来院时请佩戴口罩，如无法按时前往就诊，请在就诊日0点前取消预约',
          'pass': '66780942',
          'patNum': '15',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': 15,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659628800000,
          'compareVO': null
        }
      ]
    }],
    otherFlowNodeList: [{
      'type': 1,
      'isGroup': 0,
      'hasCurrent': null,
      'guideList': [
        {
          'id': 17055,
          'patientName': '小鲸',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '妇科门诊',
          'doctorName': '',
          'shift': '下午',
          'clinicTime': 1659507960000,
          'type': 'A',
          'childTypeKey': 100,
          'childType': '预约挂号',
          'typeStatus': 1,
          'description': '距离您的预约还有<span class=\'emphatic-card-text\'>0</span>天，请在<span class=\'emphatic-card-text\'>08月03日上午09:00-09:30</span>到达医院',
          'guideText': '请在<span class=\'emphatic-card-text\'>08月03日下午13:56-14:26</span>到达医院',
          'remark': '来院时请佩戴口罩，如无法按时前往就诊，请在就诊日0点前取消预约',
          'pass': '',
          'patNum': '17',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': 15,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        }
      ]
    },
    {
      'type': 2,
      'isGroup': 0,
      'hasCurrent': 1,
      'guideList': [
        {
          'id': 17056,
          'patientName': '小鲸',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '',
          'shift': '下午',
          'clinicTime': 1659507960000,
          'type': 'A',
          'childTypeKey': 110,
          'childType': '去医院',
          'typeStatus': 0,
          'description': '请在<span class=\'emphatic-card-text\'>08月03日下午13:56-14:26</span>到达医院',
          'guideText': '请在<span class=\'emphatic-card-text\'>08月03日下午13:56-14:26</span>到达医院',
          'remark': '到院后请凭有效证件至自助挂号机或人工窗口取号',
          'pass': '',
          'patNum': '17',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 1,
          'totalAmount': 15,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        }
      ]
    },
    {
      'type': 3,
      'isGroup': 1,
      'hasCurrent': null,
      'guideList': [
        {
          'id': 17054,
          'patientName': '小鲸',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '',
          'shift': '下午',
          'clinicTime': 1659507960000,
          'type': 'A',
          'childTypeKey': 120,
          'childType': '去取号',
          'typeStatus': 0,
          'description': '请凭有效证件前往各楼层自助挂号机或人工窗口取号',
          'guideText': '请前往各楼层自助挂号机取号',
          'remark': '请根据挂号凭条信息前往相应诊室签到',
          'pass': '',
          'patNum': '17',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': 15,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 17052,
          'patientName': '小鲸',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '21204',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '陈瑞哲',
          'shift': '下午',
          'clinicTime': 1659507936000,
          'type': 'C',
          'childTypeKey': 210,
          'childType': '去签到',
          'typeStatus': 0,
          'description': '请前往<span class=\'emphatic-card-text\'>宫颈疾病专科门诊</span>，在自助签到机签到候诊',
          'guideText': '请前往<span class=\'emphatic-card-text\'>宫颈疾病专科门诊</span>，在自助签到机签到候诊',
          'remark': '可以通过输入病案号、扫描挂号单二维码、刷自费卡等方式进行签到',
          'pass': '',
          'patNum': '17',
          'currentNum': '16',
          'currentName': '小鲸',
          'waitNum': '0',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': 0,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 17051,
          'patientName': '小鲸',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '21204',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '陈瑞哲',
          'shift': '下午',
          'clinicTime': 1659507936000,
          'type': 'C',
          'childTypeKey': 250,
          'childType': '去就诊',
          'typeStatus': 0,
          'description': '请在<span class=\'emphatic-card-text\'>1号楼6楼B区</span>候诊，关注现场叫号信息，听到呼叫后请前往诊室门口候诊',
          'guideText': '请在<span class=\'emphatic-card-text\'>1号楼6楼B区</span>候诊，当前还需等待<span class=\'emphatic-card-text\'>0</span>人，听到呼叫后请前往诊室门口候诊',
          'remark': '70岁及以上老年人本人、残疾人、现役军人，可凭证件优先照顾',
          'pass': '',
          'patNum': '17',
          'currentNum': '16',
          'currentName': '小鲸',
          'waitNum': '0',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': 0,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 17053,
          'patientName': '小鲸',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '21204',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '陈瑞哲',
          'shift': '下午',
          'clinicTime': 1659507936000,
          'type': 'C',
          'childTypeKey': 310,
          'childType': '门诊中',
          'typeStatus': 0,
          'description': '医生接诊中',
          'guideText': '医生接诊中',
          'remark': '',
          'pass': '',
          'patNum': '17',
          'currentNum': '16',
          'currentName': '小鲸',
          'waitNum': '0',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        }
      ]
    },
    {
      'type': 4,
      'isGroup': 0,
      'hasCurrent': null,
      'guideList': [
        {
          'id': 17074,
          'patientName': '小鲸',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '21204',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '陈瑞哲',
          'shift': '',
          'clinicTime': 1659495771000,
          'type': 'D',
          'childTypeKey': 330,
          'childType': '去缴费',
          'typeStatus': 0,
          'description': '您有一张新的缴费结算单，点击查看清单可查看缴费单详情',
          'guideText': '您有一张新的缴费结算单，点击查看清单可查看缴费单详情',
          'remark': '请及时在自助机或人工窗口缴费，在线缴费仅支持自费。医生诊间预约好的检查请留意手机短信',
          'pass': '',
          'patNum': '',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': 165,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        }
      ]
    },
    {
      'type': 5,
      'isGroup': 0,
      'hasCurrent': null,
      'guideList': []
    },
    {
      'type': 6,
      'isGroup': 1,
      'hasCurrent': null,
      'guideList': [
        {
          'id': 17090,
          'patientName': '小鲸',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '21204',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '陈瑞哲',
          'shift': '',
          'clinicTime': 1659495771000,
          'type': 'D',
          'childTypeKey': 420,
          'childType': '去检查（超声）·取号-经阴道三维子宫附件超声检查',
          'typeStatus': 0,
          'description': '以下项目检查当日请到<span class=\'emphatic-card-text\'>各就诊楼层超声取号机上自助取号，并至相应科室先签到再等候检查！(检查前请排空小便)。如需预约，请在微信公众号上预约！',
          'guideText': '以下项目检查当日请到<span class=\'emphatic-card-text\'>各就诊楼层超声取号机上自助取号，并至相应科室先签到再等候检查！(检查前请排空小便)。如需预约，请在微信公众号上预约！',
          'remark': '',
          'pass': '',
          'patNum': '',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '经阴道三维子宫附件超声检查',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 17067,
          'patientName': '小鲸',
          'patientCard': '06452878',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '超声二科',
          'doctorName': '',
          'shift': '上午',
          'clinicTime': null,
          'type': 'D',
          'childTypeKey': 424,
          'childType': '去检查（超声）·签到·经阴道三维子宫附件超声检查',
          'typeStatus': 0,
          'description': '请前往<span class=\'emphatic-card-text\'>2号楼2楼超声二科</span>，扫码或者输入病案号在自助签到机签到',
          'guideText': '请前往<span class=\'emphatic-card-text\'>2号楼2楼超声二科</span>，扫码或者输入病案号在自助签到机签到',
          'remark': '最早可按候诊时间提前1小时签到，超过候诊时间1小时未签到者，由服务台人工安排',
          'pass': '',
          'patNum': '7155',
          'currentNum': '',
          'currentName': '',
          'waitNum': '0',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '经阴道三维子宫附件超声检查',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 17071,
          'patientName': '小鲸',
          'patientCard': '06452878',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '超声二科',
          'doctorName': '',
          'shift': '上午',
          'clinicTime': null,
          'type': 'D',
          'childTypeKey': 425,
          'childType': '去检查（超声）·就诊·经阴道三维子宫附件超声检查',
          'typeStatus': 0,
          'description': '请在<span class=\'emphatic-card-text\'>2号楼2楼超声二科</span>等待检查，关注现场叫号信息。当前还需等待大约<span class=\'emphatic-card-text\'>0</span>人',
          'guideText': '请在<span class=\'emphatic-card-text\'>2号楼2楼超声二科</span>等待检查，关注现场叫号信息。当前还需等待大约<span class=\'emphatic-card-text\'>0</span>人',
          'remark': '请按照检验回执单提示，前往相应区域自助取单机扫码或输入病案号取检验报告',
          'pass': '',
          'patNum': '7155',
          'currentNum': '',
          'currentName': '',
          'waitNum': '0',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '经阴道三维子宫附件超声检查',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        }
      ]
    },
    {
      'type': 7,
      'isGroup': 1,
      'hasCurrent': null,
      'guideList': [
        {
          'id': 17089,
          'patientName': '小鲸',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '21204',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '陈瑞哲',
          'shift': '',
          'clinicTime': 1659495771000,
          'type': 'D',
          'childTypeKey': 411,
          'childType': '去检验·取号-人附睾分泌蛋白(HE4)测定',
          'typeStatus': 0,
          'description': '以下项目周一至周五请就近到<span class=\'emphatic-card-text\'>1号楼3楼或3号楼3楼检验中心</span>执行；周六周日请到<span class=\'emphatic-card-text\'>1号楼3楼检验中心</span>执行(节假日除外)',
          'guideText': '以下项目周一至周五请就近到<span class=\'emphatic-card-text\'>1号楼3楼或3号楼3楼检验中心</span>执行；周六周日请到<span class=\'emphatic-card-text\'>1号楼3楼检验中心</span>执行(节假日除外)',
          'remark': '',
          'pass': '',
          'patNum': '',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '人附睾分泌蛋白(HE4)测定',
          'deptWaitTime': null,
          'suggestionAddress': '建议取号地址:3号楼3楼检验中心，预计等候人数:10',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 17072,
          'patientName': '小鲸',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '3301',
          'deptName': '检验科',
          'doctorName': '3号楼3楼抽血',
          'shift': '不区分上下午',
          'clinicTime': null,
          'type': 'D',
          'childTypeKey': 413,
          'childType': '去检验·就诊',
          'typeStatus': 0,
          'description': '当前还需等待<span class=\'emphatic-card-text\'>0</span>人后可检验',
          'guideText': '当前还需等待<span class=\'emphatic-card-text\'>0</span>人后可检验',
          'remark': '您当前共有1个检验项目',
          'pass': '',
          'patNum': '422',
          'currentNum': '458',
          'currentName': '',
          'waitNum': '-36',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        }
      ]
    },
    {
      'type': 8,
      'isGroup': 1,
      'hasCurrent': 1,
      'guideList': [
        {
          'id': 3611496,
          'patientName': '小鲸',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '普通内科',
          'doctorName': '',
          'shift': '下午',
          'clinicTime': 1659682440000,
          'type': 'A',
          'childTypeKey': 100,
          'childType': '预约挂号',
          'typeStatus': 1,
          'description': '距离您的预约还有<span class=\'emphatic-card-text\'>2</span>天，请在<span class=\'emphatic-card-text\'>08月05日下午14:24-14:54</span>到达医院',
          'guideText': '请在<span class=\'emphatic-card-text\'>08月05日下午14:24-14:54</span>到达医院',
          'remark': '来院时请佩戴口罩，如无法按时前往就诊，请在就诊日0点前取消预约',
          'pass': '66780942',
          'patNum': '17',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': 15,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659628800000,
          'compareVO': null
        },
        {
          'id': 3611497,
          'patientName': '小鲸',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '普通内科',
          'doctorName': '',
          'shift': '下午',
          'clinicTime': 1659682440000,
          'type': 'A',
          'childTypeKey': 110,
          'childType': '去医院',
          'typeStatus': 0,
          'description': '请在<span class=\'emphatic-card-text\'>08月05日下午14:24-14:54</span>到达医院',
          'guideText': '请在<span class=\'emphatic-card-text\'>08月05日下午14:24-14:54</span>到达医院',
          'remark': '到院后请凭有效证件至自助挂号机或人工窗口取号',
          'pass': '66780942',
          'patNum': '15',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 1,
          'totalAmount': 15,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659628800000,
          'compareVO': null
        },
        {
          'id': 3611495,
          'patientName': '小鲸',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '普通内科',
          'doctorName': '',
          'shift': '下午',
          'clinicTime': 1659682440000,
          'type': 'A',
          'childTypeKey': 120,
          'childType': '去取号',
          'typeStatus': 0,
          'description': '请凭有效证件前往各楼层自助挂号机或人工窗口取号',
          'guideText': '请前往各楼层自助挂号机取号',
          'remark': '请根据挂号凭条信息前往相应诊室签到',
          'pass': '66780942',
          'patNum': '15',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': 15,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659628800000,
          'compareVO': null
        },
        {
          'id': 3611496,
          'patientName': '小鲸',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '普通内科',
          'doctorName': '',
          'shift': '下午',
          'clinicTime': 1659682440000,
          'type': 'A',
          'childTypeKey': 210,
          'childType': '去签到',
          'typeStatus': 0,
          'description': '请前往<span class=\'emphatic-card-text\'>1号楼2楼A区</span>，在自助签到机签到候诊',
          'guideText': '请前往<span class=\'emphatic-card-text\'>1号楼2楼A区</span>，在自助签到机签到候诊',
          'remark': '可以通过输入病案号、扫描挂号单二维码、刷自费卡等方式进行签到',
          'pass': '66780942',
          'patNum': '15',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': 15,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659628800000,
          'compareVO': null
        },
        {
          'id': 3611496,
          'patientName': '小鲸',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '普通内科',
          'doctorName': '',
          'shift': '下午',
          'clinicTime': 1659682440000,
          'type': 'A',
          'childTypeKey': 250,
          'childType': '去就诊',
          'typeStatus': 0,
          'description': '请在<span class=\'emphatic-card-text\'>1号楼2楼A区</span>候诊，关注现场叫号信息，听到呼叫后请前往诊室门口候诊',
          'guideText': '请在<span class=\'emphatic-card-text\'>1号楼2楼A区</span>候诊，关注现场叫号信息，听到呼叫后请前往诊室门口候诊',
          'remark': '来院时请佩戴口罩，如无法按时前往就诊，请在就诊日0点前取消预约',
          'pass': '66780942',
          'patNum': '15',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': 15,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659628800000,
          'compareVO': null
        }
      ]
    }],
    multipleNodeList: [{
      'type': 1,
      'isGroup': 0,
      'hasCurrent': null,
      'guideList': [
        {
          'id': 17055,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '',
          'shift': '下午',
          'clinicTime': 1659507960000,
          'type': 'A',
          'childTypeKey': 100,
          'childType': '预约挂号',
          'typeStatus': 1,
          'description': '距离您的预约还有<span class=\'emphatic-card-text\'>0</span>天，请在<span class=\'emphatic-card-text\'>08月03日上午08:00-09:10</span>到达医院',
          'guideText': '请在<span class=\'emphatic-card-text\'>08月03日上午08:00-09:10</span>到达医院',
          'remark': '来院时请佩戴口罩，如无法按时前往就诊，请在就诊日0点前取消预约',
          'pass': '',
          'patNum': '16',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': 15,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        }
      ]
    },
    {
      'type': 2,
      'isGroup': 0,
      'hasCurrent': 1,
      'guideList': [
        {
          'id': 17056,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '',
          'shift': '下午',
          'clinicTime': 1659507960000,
          'type': 'A',
          'childTypeKey': 110,
          'childType': '去医院',
          'typeStatus': 0,
          'description': '请在<span class=\'emphatic-card-text\'>08月03日上午08:00-09:10</span>到达医院',
          'guideText': '请在<span class=\'emphatic-card-text\'>08月03日上午08:00-09:10</span>到达医院',
          'remark': '到院后请凭有效证件至自助挂号机或人工窗口取号',
          'pass': '',
          'patNum': '16',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 1,
          'totalAmount': 15,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        }
      ]
    },
    {
      'type': 3,
      'isGroup': 1,
      'isMultiple': 1,
      'hasCurrent': null,
      'guideList': [
        {
          'id': 17054,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '',
          'shift': '下午',
          'clinicTime': 1659507960000,
          'type': 'A',
          'childTypeKey': 120,
          'childType': '去取号',
          'typeStatus': 0,
          'description': '请凭有效证件前往各楼层自助挂号机或人工窗口取号',
          'guideText': '请前往各楼层自助挂号机取号',
          'remark': '请根据挂号凭条信息前往相应诊室签到',
          'pass': '',
          'patNum': '16',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': 15,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': 10,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 17052,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '21204',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '陈瑞哲',
          'shift': '下午',
          'clinicTime': 1659507936000,
          'type': 'C',
          'childTypeKey': 210,
          'childType': '去签到',
          'typeStatus': 0,
          'description': '请前往<span class=\'emphatic-card-text\'>宫颈疾病专科门诊</span>，在自助签到机签到候诊',
          'guideText': '请前往<span class=\'emphatic-card-text\'>宫颈疾病专科门诊</span>，在自助签到机签到候诊',
          'remark': '可以通过输入病案号、扫描挂号单二维码、刷自费卡等方式进行签到',
          'pass': '',
          'patNum': '16',
          'currentNum': '16',
          'currentName': '小祺',
          'waitNum': '0',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': 15,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 17051,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '21204',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '陈瑞哲',
          'shift': '下午',
          'clinicTime': 1659507936000,
          'type': 'C',
          'childTypeKey': 250,
          'childType': '去就诊',
          'typeStatus': 0,
          'description': '请在<span class=\'emphatic-card-text\'>1号楼6楼B区</span>候诊，关注现场叫号信息，听到呼叫后请前往诊室门口候诊',
          'guideText': '请在<span class=\'emphatic-card-text\'>1号楼6楼B区</span>候诊，当前还需等待<span class=\'emphatic-card-text\'>0</span>人，听到呼叫后请前往诊室门口候诊',
          'remark': '70岁及以上老年人本人、残疾人、现役军人，可凭证件优先照顾',
          'pass': '',
          'patNum': '16',
          'currentNum': '16',
          'currentName': '小祺',
          'waitNum': '0',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': 5,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 17053,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '21204',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '陈瑞哲',
          'shift': '下午',
          'clinicTime': 1659507936000,
          'type': 'C',
          'childTypeKey': 310,
          'childType': '门诊中',
          'typeStatus': 0,
          'description': '医生接诊中',
          'guideText': '医生接诊中',
          'remark': '',
          'pass': '',
          'patNum': '16',
          'currentNum': '16',
          'currentName': '小祺',
          'waitNum': '0',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 170541,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '普通妇科',
          'doctorName': '',
          'shift': '下午',
          'clinicTime': 1659507960000,
          'type': 'A',
          'childTypeKey': 120,
          'childType': '去取号',
          'typeStatus': 0,
          'description': '请凭有效证件前往各楼层自助挂号机或人工窗口取号',
          'guideText': '请前往各楼层自助挂号机取号',
          'remark': '请根据挂号凭条信息前往相应诊室签到',
          'pass': '',
          'patNum': '16',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': 15,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': 20,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 170521,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '21204',
          'deptName': '普通妇科',
          'doctorName': '陈瑞哲',
          'shift': '下午',
          'clinicTime': 1659507936000,
          'type': 'C',
          'childTypeKey': 210,
          'childType': '去签到',
          'typeStatus': 0,
          'description': '请前往<span class=\'emphatic-card-text\'>1号楼3楼A区普通妇科</span>，在自助签到机签到候诊',
          'guideText': '请前往<span class=\'emphatic-card-text\'>1号楼3楼A区普通妇科</span>，在自助签到机签到候诊',
          'remark': '可以通过输入病案号、扫描挂号单二维码、刷自费卡等方式进行签到',
          'pass': '',
          'patNum': '16',
          'currentNum': '16',
          'currentName': '小祺',
          'waitNum': '0',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': 25,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 170511,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '21204',
          'deptName': '普通妇科',
          'doctorName': '陈瑞哲',
          'shift': '下午',
          'clinicTime': 1659507936000,
          'type': 'C',
          'childTypeKey': 250,
          'childType': '去就诊',
          'typeStatus': 0,
          'description': '请在<span class=\'emphatic-card-text\'>1号楼3楼A区</span>候诊，关注现场叫号信息，听到呼叫后请前往诊室门口候诊',
          'guideText': '请在<span class=\'emphatic-card-text\'>1号楼3楼A区</span>候诊，当前还需等待<span class=\'emphatic-card-text\'>2</span>人，听到呼叫后请前往诊室门口候诊',
          'remark': '70岁及以上老年人本人、残疾人、现役军人，可凭证件优先照顾',
          'pass': '',
          'patNum': '16',
          'currentNum': '16',
          'currentName': '小祺',
          'waitNum': '0',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': 35,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 170531,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '21204',
          'deptName': '普通妇科',
          'doctorName': '陈瑞哲',
          'shift': '下午',
          'clinicTime': 1659507936000,
          'type': 'C',
          'childTypeKey': 310,
          'childType': '门诊中',
          'typeStatus': 0,
          'description': '医生接诊中',
          'guideText': '医生接诊中',
          'remark': '',
          'pass': '',
          'patNum': '16',
          'currentNum': '16',
          'currentName': '小祺',
          'waitNum': '0',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        }
      ]
    },
    {
      'type': 4,
      'isGroup': 0,
      'hasCurrent': null,
      'guideList': [
        {
          'id': 17074,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '21204',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '陈瑞哲',
          'shift': '',
          'clinicTime': 1659495771000,
          'type': 'D',
          'childTypeKey': 330,
          'childType': '去缴费',
          'typeStatus': 0,
          'description': '您有一张新的缴费结算单，点击查看清单可查看缴费单详情',
          'guideText': '您有一张新的缴费结算单，点击查看清单可查看缴费单详情',
          'remark': '请及时在自助机或人工窗口缴费，在线缴费仅支持自费。医生诊间预约好的检查请留意手机短信',
          'pass': '',
          'patNum': '',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': 165,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        }
      ]
    },
    {
      'type': 5,
      'isGroup': 0,
      'hasCurrent': null,
      'guideList': []
    },
    {
      'type': 6,
      'isGroup': 1,
      'hasCurrent': null,
      'isMultiple': 1,
      'guideList': [
        {
          'id': 17090,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '21204',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '陈瑞哲',
          'shift': '',
          'clinicTime': 1659495771000,
          'type': 'D',
          'childTypeKey': 420,
          'childType': '去检查（超声）·取号-经阴道三维子宫附件超声检查',
          'typeStatus': 0,
          'description': '以下项目检查当日请到<span class=\'emphatic-card-text\'>各就诊楼层超声取号机上自助取号，并至相应科室先签到再等候检查！(检查前请排空小便)。如需预约，请在微信公众号上预约！',
          'guideText': '以下项目检查当日请到<span class=\'emphatic-card-text\'>各就诊楼层超声取号机上自助取号，并至相应科室先签到再等候检查！(检查前请排空小便)。如需预约，请在微信公众号上预约！',
          'remark': '',
          'pass': '',
          'patNum': '',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '经阴道三维子宫附件超声检查',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 17067,
          'patientName': '小祺',
          'patientCard': '06452878',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '超声二科',
          'doctorName': '',
          'shift': '上午',
          'clinicTime': null,
          'type': 'D',
          'childTypeKey': 424,
          'childType': '去检查（超声）·签到·经阴道三维子宫附件超声检查',
          'typeStatus': 0,
          'description': '请前往<span class=\'emphatic-card-text\'>2号楼2楼超声二科</span>，扫码或者输入病案号在自助签到机签到',
          'guideText': '请前往<span class=\'emphatic-card-text\'>2号楼2楼超声二科</span>，扫码或者输入病案号在自助签到机签到',
          'remark': '最早可按候诊时间提前1小时签到，超过候诊时间1小时未签到者，由服务台人工安排',
          'pass': '',
          'patNum': '7155',
          'currentNum': '',
          'currentName': '',
          'waitNum': '0',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '经阴道三维子宫附件超声检查',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 17071,
          'patientName': '小祺',
          'patientCard': '06452878',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '超声二科',
          'doctorName': '',
          'shift': '上午',
          'clinicTime': null,
          'type': 'D',
          'childTypeKey': 425,
          'childType': '去检查（超声）·就诊·经阴道三维子宫附件超声检查',
          'typeStatus': 0,
          'description': '请在<span class=\'emphatic-card-text\'>2号楼2楼超声二科</span>等待检查，关注现场叫号信息。当前还需等待大约<span class=\'emphatic-card-text\'>0</span>人',
          'guideText': '请在<span class=\'emphatic-card-text\'>2号楼2楼超声二科</span>等待检查，关注现场叫号信息。当前还需等待大约<span class=\'emphatic-card-text\'>0</span>人',
          'remark': '请按照检验回执单提示，前往相应区域自助取单机扫码或输入病案号取检验报告',
          'pass': '',
          'patNum': '7155',
          'currentNum': '',
          'currentName': '',
          'waitNum': '0',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '经阴道三维子宫附件超声检查',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 17090,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '21204',
          'deptName': '生殖内分泌门诊',
          'doctorName': '高惠娟',
          'shift': '',
          'clinicTime': 1658910179000,
          'type': 'D',
          'childTypeKey': 420,
          'childType': '去检查·取号·卵泡监测',
          'typeStatus': 0,
          'description': '以下项目请到<span class="emphatic-card-text">3号楼生殖科1楼或4楼门诊B超取号机取号后至就诊医生诊室等候检查',
          'guideText': '以下项目请到<span class="emphatic-card-text">3号楼生殖科1楼或4楼门诊B超取号机取号后至就诊医生诊室等候检查',
          'remark': '',
          'pass': '',
          'patNum': '',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '血清促黄体生成素测定',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 17067,
          'patientName': '小祺',
          'patientCard': '06452878',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '生殖内分泌门诊',
          'doctorName': '高惠娟',
          'shift': '上午',
          'clinicTime': null,
          'type': 'D',
          'childTypeKey': 424,
          'childType': '去检查·签到·卵泡监测',
          'typeStatus': 0,
          'description': '请前往<span class="emphatic-card-text">浙大妇院-生殖内分泌门诊</span>的分诊台进行签到。<span class="emphatic-card-text">3号楼1楼生殖门诊</span>,向分诊台出示条形码登记候诊。',
          'guideText': '请前往<span class="emphatic-card-text">浙大妇院-生殖内分泌门诊</span>的分诊台进行签到。<span class="emphatic-card-text">3号楼1楼生殖门诊</span>,向分诊台出示条形码登记候诊。',
          'remark': '可以通过输入病案号、扫描挂号单二维码、刷自费卡等方式进行签到',
          'pass': '',
          'patNum': '7155',
          'currentNum': '',
          'currentName': '',
          'waitNum': '0',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '血清促黄体生成素测定',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 17071,
          'patientName': '小祺',
          'patientCard': '06452878',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '妇科专家',
          'doctorName': '',
          'shift': '上午',
          'clinicTime': null,
          'type': 'D',
          'childTypeKey': 425,
          'childType': '去检查·就诊·卵泡监测',
          'typeStatus': 0,
          'description': '请在<span class="emphatic-card-text">生殖门诊名医||高惠娟</span>候诊，关注现场叫号信息，听到呼叫后请前往诊室门口候诊',
          'guideText': '请在<span class="emphatic-card-text">生殖门诊名医||高惠娟</span>候诊，关注现场叫号信息，听到呼叫后请前往诊室门口候诊',
          'remark': '排队叫号以现场情况为准',
          'pass': '',
          'patNum': '7155',
          'currentNum': '',
          'currentName': '',
          'waitNum': '0',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '血清促黄体生成素测定',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        }
      ]
    },
    {
      'type': 7,
      'isGroup': 1,
      'hasCurrent': null,
      'isMultiple': 1,
      'guideList': [
        {
          'id': 17089,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '21204',
          'deptName': '宫颈疾病专科门诊',
          'doctorName': '陈瑞哲',
          'shift': '',
          'clinicTime': 1659495771000,
          'type': 'D',
          'childTypeKey': 411,
          'childType': '去检验·取号-人附睾分泌蛋白(HE4)测定',
          'typeStatus': 0,
          'description': '以下项目周一至周五请就近到<span class=\'emphatic-card-text\'>1号楼3楼或3号楼3楼检验中心</span>执行；周六周日请到<span class=\'emphatic-card-text\'>1号楼3楼检验中心</span>执行(节假日除外)',
          'guideText': '以下项目周一至周五请就近到<span class=\'emphatic-card-text\'>1号楼3楼或3号楼3楼检验中心</span>执行；周六周日请到<span class=\'emphatic-card-text\'>1号楼3楼检验中心</span>执行(节假日除外)',
          'remark': '',
          'pass': '',
          'patNum': '',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '人附睾分泌蛋白(HE4)测定',
          'deptWaitTime': null,
          'suggestionAddress': '建议取号地址:3号楼3楼检验中心，预计等候人数:3',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 17089,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '21204',
          'deptName': '生殖内分泌门诊',
          'doctorName': '祝文婷',
          'shift': '',
          'clinicTime': 1659495771000,
          'type': 'D',
          'childTypeKey': 411,
          'childType': '去检验·取号-尿常规',
          'typeStatus': 0,
          'description': '以下项目周一至周五请就近到<span class="emphatic-card-text">1号楼3楼或3号楼3楼检验中心</span>执行；周六周日请到<span class="emphatic-card-text">1号楼3楼检验中心</span>执行(节假日除外 )!',
          'guideText': '以下项目周一至周五请就近到<span class="emphatic-card-text">1号楼3楼或3号楼3楼检验中心</span>执行；周六周日请到<span class="emphatic-card-text">1号楼3楼检验中心</span>执行(节假日除外 )!',
          'remark': '',
          'pass': '',
          'patNum': '',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '尿常规',
          'deptWaitTime': null,
          'suggestionAddress': '建议取号地址:3号楼3楼检验中心，预计等候人数:10',
          'happenDate': 1659456000000,
          'compareVO': null
        },
        {
          'id': 17072,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '3301',
          'deptName': '生殖内分泌门诊',
          'doctorName': '祝文婷',
          'shift': '不区分上下午',
          'clinicTime': null,
          'type': 'D',
          'childTypeKey': 413,
          'childType': '去检验·就诊',
          'typeStatus': 0,
          'description': '当前还需等待<span class=\'emphatic-card-text\'>1</span>人后可检验',
          'guideText': '当前还需等待<span class=\'emphatic-card-text\'>1</span>人后可检验',
          'remark': '您当前共有2个检验项目',
          'pass': '',
          'patNum': '422',
          'currentNum': '458',
          'currentName': '',
          'waitNum': '-36',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': null,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '尿常规',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659456000000,
          'compareVO': null
        }
      ]
    },
    {
      'type': 8,
      'isGroup': 1,
      'hasCurrent': 1,
      'guideList': [
        {
          'id': 3611496,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '普通内科',
          'doctorName': '',
          'shift': '下午',
          'clinicTime': 1659682440000,
          'type': 'A',
          'childTypeKey': 100,
          'childType': '预约挂号',
          'typeStatus': 1,
          'description': '距离您的预约还有<span class=\'emphatic-card-text\'>2</span>天，请在<span class=\'emphatic-card-text\'>08月05日下午14:24-14:54</span>到达医院',
          'guideText': '请在<span class=\'emphatic-card-text\'>08月05日下午14:24-14:54</span>到达医院',
          'remark': '来院时请佩戴口罩，如无法按时前往就诊，请在就诊日0点前取消预约',
          'pass': '66780942',
          'patNum': '15',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': 15,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659628800000,
          'compareVO': null
        },
        {
          'id': 3611497,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '普通内科',
          'doctorName': '',
          'shift': '下午',
          'clinicTime': 1659682440000,
          'type': 'A',
          'childTypeKey': 110,
          'childType': '去医院',
          'typeStatus': 0,
          'description': '请在<span class=\'emphatic-card-text\'>08月05日下午14:24-14:54</span>到达医院',
          'guideText': '请在<span class=\'emphatic-card-text\'>08月05日下午14:24-14:54</span>到达医院',
          'remark': '到院后请凭有效证件至自助挂号机或人工窗口取号',
          'pass': '66780942',
          'patNum': '15',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 1,
          'totalAmount': 15,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659628800000,
          'compareVO': null
        },
        {
          'id': 3611495,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '普通内科',
          'doctorName': '',
          'shift': '下午',
          'clinicTime': 1659682440000,
          'type': 'A',
          'childTypeKey': 120,
          'childType': '去取号',
          'typeStatus': 0,
          'description': '请凭有效证件前往各楼层自助挂号机或人工窗口取号',
          'guideText': '请前往各楼层自助挂号机取号',
          'remark': '请根据挂号凭条信息前往相应诊室签到',
          'pass': '66780942',
          'patNum': '15',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': 15,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659628800000,
          'compareVO': null
        },
        {
          'id': 3611496,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '普通内科',
          'doctorName': '',
          'shift': '下午',
          'clinicTime': 1659682440000,
          'type': 'A',
          'childTypeKey': 210,
          'childType': '去签到',
          'typeStatus': 0,
          'description': '请前往<span class=\'emphatic-card-text\'>1号楼2楼A区</span>，在自助签到机签到候诊',
          'guideText': '请前往<span class=\'emphatic-card-text\'>1号楼2楼A区</span>，在自助签到机签到候诊',
          'remark': '可以通过输入病案号、扫描挂号单二维码、刷自费卡等方式进行签到',
          'pass': '66780942',
          'patNum': '15',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': 15,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659628800000,
          'compareVO': null
        },
        {
          'id': 3611496,
          'patientName': '小祺',
          'patientCard': 'xxxx7918',
          'orgName': '浙大妇院',
          'deptId': '',
          'deptName': '普通内科',
          'doctorName': '',
          'shift': '下午',
          'clinicTime': 1659682440000,
          'type': 'A',
          'childTypeKey': 250,
          'childType': '去就诊',
          'typeStatus': 0,
          'description': '请在<span class=\'emphatic-card-text\'>1号楼2楼A区</span>候诊，关注现场叫号信息，听到呼叫后请前往诊室门口候诊',
          'guideText': '请在<span class=\'emphatic-card-text\'>1号楼2楼A区</span>候诊，关注现场叫号信息，听到呼叫后请前往诊室门口候诊',
          'remark': '来院时请佩戴口罩，如无法按时前往就诊，请在就诊日0点前取消预约',
          'pass': '66780942',
          'patNum': '15',
          'currentNum': '',
          'currentName': '',
          'waitNum': '',
          'currentPatientNum': null,
          'currentStatus': 0,
          'totalAmount': 15,
          'billVO': null,
          'appointmentState': '0',
          'itemName': '',
          'deptWaitTime': null,
          'suggestionAddress': '',
          'happenDate': 1659628800000,
          'compareVO': null
        }
      ]
    }],
    planList: [{
      'planDate': '',
      'voList': [
        {
          'detailId': '1',
          'patientName': '小祺',
          'functionTypeIds': [1],
          'message': '请在08月29日下午15:30-16:00到达医院',
          'planDate': '08月29日',
          'planStatus': 1,
          'planType': 1,
          'todayFlag': true
        },
        {
          'detailId': '2',
          'patientName': '小祺',
          'functionTypeIds': [1],
          'message': '请在9月29日下午8:30-9:00到达医院',
          'planDate': '09月29日',
          'planStatus': 1,
          'planType': 1,
          'todayFlag': false
        }
      ]
    }],
    planListTotal: [{
      'planDate': '',
      'voList': [
        {
          'detailId': '1',
          'patientName': '小祺',
          'functionTypeIds': [1],
          'message': '请在08月29日下午15:30-16:00到达医院',
          'planDate': '08月29日',
          'planStatus': 1,
          'planType': 1,
          'todayFlag': true
        },
        {
          'detailId': '2',
          'patientName': '小祺',
          'functionTypeIds': [1],
          'message': '请在9月29日下午8:30-9:00到达医院',
          'planDate': '09月29日',
          'planStatus': 1,
          'planType': 1,
          'todayFlag': false
        },
        {
          'detailId': '3',
          'patientName': '小祺',
          'functionTypeIds': [2],
          'message': '请9月25日完成1项检查',
          'planDate': '09月25日',
          'planStatus': 1,
          'planType': 2,
          'todayFlag': false
        },
        {
          'detailId': '4',
          'patientName': '小祺',
          'functionTypeIds': [5],
          'message': '您有一份妇科张三开具从<span style=\'color:red\'>8月27日-9月23日</span>的用药计划',
          'planDate': '09月23日',
          'planStatus': 1,
          'planType': 5,
          'todayFlag': true
        }
      ]
    }],
    recommendList: [
      [
        {
          'recommendName': '预约检查',
          'recommendUrl': '/reservation-notice',
        },
        {
          'recommendName': '预问诊',
          'recommendUrl': '/pre-consultation/patient-info',
        },
        {
          'recommendName': '智能自诊',
          'recommendUrl': '/self-diagnosis/patient-info',
        },
        {
          'recommendName': 'AI小助手',
          'recommendUrl': '/faq',
        }
      ],[
        {
          'recommendName': '预问诊',
          'recommendUrl': '/pre-consultation/patient-info',
        },
        {
          'recommendName': '智能自诊',
          'recommendUrl': '/self-diagnosis/patient-info',
        },
        {
          'recommendName': '疾病知识',
          'recommendUrl': '/health-encyclopedia',
        },
        {
          'recommendName': 'AI小助手',
          'recommendUrl': '/faq',
        }
      ],[
        {
          'recommendName': '疾病知识',
          'recommendUrl': '/health-encyclopedia',
        },
        {
          'recommendName': '药品百科',
          'recommendUrl': '/drug-assistant',
        },
        {
          'recommendName': '检查检验百科',
          'recommendUrl': '/exam-test',
        },
        {
          'recommendName': 'AI小助手',
          'recommendUrl': '/faq',
        }
      ],[
        {
          'recommendName': '药品百科',
          'recommendUrl': '/drug-assistant',
        },
        {
          'recommendName': '检查检验百科',
          'recommendUrl': '/exam-test',
        },
        {
          'recommendName': 'AI小助手',
          'recommendUrl': '/faq',
        }
      ],[
        {
          'recommendName': '检查检验百科',
          'recommendUrl': '/exam-test',
        },
        {
          'recommendName': '药品百科',
          'recommendUrl': '/drug-assistant',
        },
        {
          'recommendName': '疾病知识',
          'recommendUrl': '/health-encyclopedia',
        },
      ],[
        {
          'recommendName': '报告解读',
          'recommendUrl': '/report-query',
        },
        {
          'recommendName': 'AI小助手',
          'recommendUrl': '/faq',
        }
      ]
    ],
    doctorAdvice: [{
      'visitNo': '1',
      'registerNo': '1',
      'patientName': '祝玉荣',
      'doDate': 1658912423000,
      'dr': '张三',
      'drName': '张三',
      'orderNo': '13213',
      'deptName': '外科',
      'orderList': [{
        'id': 1,
        'visitNo': '1',
        'registerNo': '1',
        'patientName': '祝玉荣',
        'doDate': 1658912423000,
        'dr': '张三',
        'drName': '张三',
        'deptId': '1',
        'deptName': '',
        'orderFlag': 'D',
        'orderType': '1',
        'orderNumber': '1',
        'prescriptNo': '1',
        'orderNo': '1',
        'orderName': '阿莫西林',
        'orderCode': '1',
        'useDays': '10',
        'frequency': '一天三次',
        'admission': '口服',
        'dosage': '1',
        'dosageUnit': '粒',
        'totalCount': '2',
        'totalCountUnit': '盒',
        'orderMark': '饭前食用',
        'type': '',
        'tsCreate': null
      },
      {
        'id': 1,
        'visitNo': '1',
        'registerNo': '1',
        'patientName': '祝玉荣',
        'doDate': 1658912423000,
        'dr': '张三',
        'drName': '张三',
        'deptId': '1',
        'deptName': '',
        'orderFlag': 'D',
        'orderType': '1',
        'orderNumber': '1',
        'prescriptNo': '1',
        'orderNo': '1',
        'orderName': '氯芬黄敏片',
        'orderCode': '1',
        'useDays': '10',
        'frequency': '一天三次',
        'admission': '口服',
        'dosage': '1',
        'dosageUnit': '粒',
        'totalCount': '2',
        'totalCountUnit': '盒',
        'orderMark': '饭前食用',
        'type': '',
        'tsCreate': null
      },
      {
        'id': 1,
        'visitNo': '1',
        'registerNo': '1',
        'patientName': '祝玉荣',
        'doDate': 1658912423000,
        'dr': '张三',
        'drName': '张三',
        'deptId': '1',
        'deptName': '',
        'orderFlag': 'D',
        'orderType': '2',
        'orderNumber': '1',
        'prescriptNo': '1',
        'orderNo': '1',
        'orderName': '感冒清热颗粒',
        'orderCode': '1',
        'useDays': '3',
        'frequency': '一天两次',
        'admission': '开水冲服',
        'dosage': '1',
        'dosageUnit': '袋',
        'totalCount': '2',
        'totalCountUnit': '盒',
        'orderMark': '忌烟、酒及辛辣、生冷、油腻食物',
        'type': '',
        'tsCreate': null
      },
      {
        'id': 1,
        'visitNo': '1',
        'registerNo': '1',
        'patientName': '祝玉荣',
        'doDate': 1658912423000,
        'dr': '张三',
        'drName': '张三',
        'deptId': '1',
        'deptName': '',
        'orderFlag': 'D',
        'orderType': '3',
        'orderNumber': '1',
        'prescriptNo': '1',
        'orderNo': '1',
        'orderName': '郁金,白药,吃赤药,红花藏红花,桃仁,丹参芍药',
        'orderCode': '1',
        'useDays': '7',
        'frequency': '一天两次',
        'admission': '内服草药水煎服',
        'dosage': '1',
        'dosageUnit': '剂',
        'totalCount': '7',
        'totalCountUnit': '剂',
        'orderMark': '忌烟、酒及辛辣、生冷、油腻食物',
        'type': '',
        'tsCreate': null
      }]
    }],
    billList: [
      {
        'payStatus': null,
        'billName': '已收费单据',
        'invoiceNo': '0085803524',
        'patientCard': '04452230',
        'patientName': '陈沐希',
        'deptName': '新生儿门诊',
        'doctorName': '孙苓',
        'costAmount': '49.62',
        'surchargeValue': '0.00',
        'totalAmount': null,
        'expenditureList': [
          {
            'platPatientId': '',
            'platPatientName': '',
            'billId': '29157977',
            'billType': '1',
            'orderType': '0',
            'doses': '1',
            'billStatus': '0',
            'guidance': '以下药品请至3号楼1楼门诊药房1号窗口领取',
            'doctorName': '孙苓',
            'deptName': '新生儿门诊',
            'orderName': '西药',
            'billDate': 1659598690000,
            'billAmount': '                28.62',
            'preBilling': '0',
            'bookItemList': [],
            'itemList': [
              {
                'name': '维生素D滴剂（胶囊型）',
                'spec': '400IU*30',
                'unit': '盒',
                'quantity': '1',
                'price': '28.6200',
                'amount': '28.62'
              }
            ]
          },
          {
            'platPatientId': '',
            'platPatientName': '',
            'billId': '29157986',
            'billType': '1',
            'orderType': '0',
            'doses': '1',
            'billStatus': '0',
            'guidance': '以下药品请至3号楼1楼门诊药房1号窗口领取',
            'doctorName': '孙苓',
            'deptName': '新生儿门诊',
            'orderName': '西药',
            'billDate': 1659598703000,
            'billAmount': '                21.00',
            'preBilling': '0',
            'bookItemList': [],
            'itemList': [
              {
                'name': '维生素AD滴剂[伊可新]',
                'spec': '40粒',
                'unit': '盒  ',
                'quantity': '1',
                'price': '21.0000',
                'amount': '21.00'
              }
            ]
          }
        ]
      }
    ]
  },
  getters: {},
  mutations: {
    // 设置聊天信息
    SET_FLOWNODELIST(state: any, data: any) {
      state.flowNodeList = data
    },
    // 设置当前演示类型
    SET_ISMULTIPLE(state: any, data: any) {
      state.isMultiple = data
    },
    // 设置展开状态
    SET_ISCHECKED(state: any) {
      state.isChecked = !state.isChecked
    },
    //设置演示按钮位置
    SET_BUTTONTOP(state: any, data: any) {
      state.buttonTop = data
    }
  },
  actions: {}
}
